"use client";

import { createContext } from "react";

export const FactSetProviderContext = createContext({
  // placeholder default; real setter is supplied by FactSetProvider
  // oxlint-disable-next-line no-empty-function
  setIsReady: (_: boolean) => {},
  isReady: false,
});
